import { motion } from 'framer-motion';

export function DetailCard({ number, title, children, delay = 0 }) {
  return (
    <motion.div
      // initial={{ opacity: 0, y: 30 }}
      // whileInView={{ opacity: 1, y: 0 }}
      // viewport={{ once: true, margin: "-50px" }}
      // whileHover={{ 
      //   scale: 1.01,
      //   transition: { duration: 0.3, ease: [0.22, 1, 0.36, 1] }
      // }}
      // transition={{ 
      //   duration: 0.6, 
      //   delay,
      //   ease: [0.22, 1, 0.36, 1]
      // }}
      className="group flex flex-col gap-4 p-8 rounded-2xl item-border border-white/10 bg-gradient-to-br from-white/5 to-transparent backdrop-blur-sm transition-all hover:border-white/20 hover:shadow-xl hover:shadow-primary/5"
    >
      <div className="flex items-center gap-4">
        <div className="flex items-center justify-center w-10 h-10 flex-shrink-0 rounded-full bg-primary/20">
          <span className="text-[#FD5B38] text-lg font-normal">{number}</span>
        </div>
        <h3 className="text-white text-xl sm:text-2xl font-normal">
          {title}
        </h3>
      </div>
      <div className="ml-14 space-y-3">
        {children}
      </div>
    </motion.div>
  );
}
